import {connect} from 'react-redux';

import {
  frontNoSingleKeyShortcutsMapping,
  frontShortcutsMapping,
  gmailShortcutsMapping,
  legacyShortcutsMapping,
  noShortcutsMapping,
} from '../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {isElectron} from '../../../../libs/shared/helpers/src/environment/platformHelpers';
import {KeyboardProvider} from '../../../../libs/shared/ui/src/components/keyboard/keyboardProvider';
import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {KeyboardShortcutsTypesEnum} from '../../../models/api/preferencesModel';
import {getKeyboardShortcutsType} from '../../../store/data/preferences/preferencesSelectors';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  mapping: getKeyboardMapping,
}));

const getKeyboardMapping = createSelector([getKeyboardShortcutsType], (keyboardShortcutsType) => {
  switch (keyboardShortcutsType) {
    case KeyboardShortcutsTypesEnum.LEGACY:
      return legacyShortcutsMapping;
    case KeyboardShortcutsTypesEnum.NONE:
      return noShortcutsMapping;
    case KeyboardShortcutsTypesEnum.FRONT:
      return isElectron() ? frontNoSingleKeyShortcutsMapping : frontShortcutsMapping;
    case KeyboardShortcutsTypesEnum.GMAIL:
      return gmailShortcutsMapping;
    case KeyboardShortcutsTypesEnum.FRONT_NO_SINGLE_KEY:
      return frontNoSingleKeyShortcutsMapping;
    default:
      return frontShortcutsMapping;
  }
});

export const KeyboardProviderContainer = connect(mapStateToProps)(KeyboardProvider);
